
(function(){
  function formatMoney(cents, format){
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    return (format && format.indexOf('{{') > -1) ? format.replace(/\{\{\s*amount[^}]*\}\}/, value) : '$' + value;
  }
  function initPanel(panel){
    if (!panel || panel.dataset.fossiInit === 'true') return;
    panel.dataset.fossiInit = 'true';
    var form = panel.closest('form');
    if (!form) return;
    var script = form.querySelector('[data-fossi-pricing]');
    if (!script) return;
    var data;
    try { data = JSON.parse(script.textContent); } catch(e) { return; }
    var variants = data.variants || [];
    var moneyFormat = data.money_format || '${{amount}}';
    var select = form.querySelector('select[name="id"], input[name="id"]');
    var qtyInput = form.querySelector('[data-quantity-value], input[name="quantity"]');
    var totalEl = panel.querySelector('[data-fossi-selected-total]');
    var qtyEl = panel.querySelector('[data-fossi-selected-qty]');
    var titleEl = panel.querySelector('[data-fossi-selected-title]');
    var saveEl = panel.querySelector('[data-fossi-selected-save]');
    function getVariant(){
      var id = select ? String(select.value) : '';
      return variants.find(function(v){ return String(v.id) === id; }) || variants[0] || null;
    }
    function update(){
      var variant = getVariant();
      var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      if (!qty || qty < 1) qty = 1;
      if (qtyEl) qtyEl.textContent = qty;
      if (!variant) return;
      if (titleEl && variant.title && variant.title !== 'Default Title') titleEl.textContent = variant.title;
      var subtotal = (variant.price || 0) * qty;
      var compare = (variant.compare_at_price || 0) * qty;
      var save = compare > subtotal ? compare - subtotal : 0;
      if (totalEl) totalEl.textContent = formatMoney(subtotal, moneyFormat);
      if (saveEl) {
        if (save > 0) {
          var label = saveEl.getAttribute('data-label') || saveEl.textContent.split(':')[0] || 'You save';
          saveEl.textContent = label + ': ' + formatMoney(save, moneyFormat);
          saveEl.classList.add('has-save');
        } else {
          saveEl.textContent = '';
          saveEl.classList.remove('has-save');
        }
      }
    }
    if (saveEl && saveEl.textContent) saveEl.setAttribute('data-label', saveEl.textContent);
    form.addEventListener('change', function(e){ if (e.target.matches('select[name="id"], input[name="id"], [data-quantity-value], input[name="quantity"]')) update(); });
    form.addEventListener('input', function(e){ if (e.target.matches('[data-quantity-value], input[name="quantity"]')) update(); });
    var observer = new MutationObserver(update);
    if (select) observer.observe(select, {attributes:true, childList:true, subtree:false});
    if (qtyInput) observer.observe(qtyInput, {attributes:true, attributeFilter:['value']});
    update();
  }




  function moveAddonBlocks(panel){
    if (!panel) return;
    var body = panel.querySelector('.fossi-atc-panel__body');
    if (!body) return;
    var host = panel.previousElementSibling;
    if (!host || !host.hasAttribute('data-fossi-addon-host')) {
      host = document.createElement('div');
      host.className = 'fossi-addon-host';
      host.setAttribute('data-fossi-addon-host', '');
      panel.parentNode.insertBefore(host, panel);
    }
    Array.prototype.slice.call(body.children).forEach(function(node){
      if (node.classList && node.classList.contains('t4s-product-form__buttons')) return;
      host.appendChild(node);
    });
    if (!body.__fossiAddonObserver) {
      body.__fossiAddonObserver = new MutationObserver(function(){ moveAddonBlocks(panel); });
      body.__fossiAddonObserver.observe(body, {childList:true});
    }
  }

  function moveAssuranceForMobile(){
    var panel = document.querySelector('[data-fossi-atc-panel]');
    var assurance = document.querySelector('.fossi-media-assurance');
    if (!assurance) return;
    if (!assurance.__fossiPlaceholder) {
      var ph = document.createComment('fossi assurance original position');
      assurance.parentNode.insertBefore(ph, assurance);
      assurance.__fossiPlaceholder = ph;
    }
    if (window.matchMedia('(max-width: 767px)').matches) {
      if (panel && assurance.parentNode !== panel.parentNode) {
        panel.parentNode.insertBefore(assurance, panel.nextSibling);
      } else if (panel && assurance.previousElementSibling !== panel) {
        panel.parentNode.insertBefore(assurance, panel.nextSibling);
      }
    } else if (assurance.__fossiPlaceholder && assurance.__fossiPlaceholder.parentNode) {
      assurance.__fossiPlaceholder.parentNode.insertBefore(assurance, assurance.__fossiPlaceholder.nextSibling);
    }
  }

  function initAll(){
    document.querySelectorAll('[data-fossi-atc-panel]').forEach(function(panel){ initPanel(panel); moveAddonBlocks(panel); });
    moveAssuranceForMobile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', moveAssuranceForMobile);
})();
